import axios from 'axios';

const serverAPI = axios.create({
  baseURL:
    // `${process.env.REACT_APP_FE_URL}` ||
    // `https://www.alirshadtrust.org/api/api/`,
    `https://alirshadtrust.org/v1/api`,
    // "http://127.0.0.1:8000/api",
  // baseURL: `http://192.168.1.34:8000`,
});

export default serverAPI;
